
define('text!modules/T1App/templates/tabs.html',[],function () { return '<div class="w-box w-Admin">\n\t<div class="w-head">\n\t{{>header}}\n\t</div>\n\t<div class="w-body">\n\t\t<div class="apps-admin-tabs" data-bind="ignore"></div>\n\t</div>\n</div>';});

